import GIPolicy from '../containers/GIPolicy'
import NewGIPolicyContainer from '../containers/NewGIPolicyContainer'
import GIPolicyList from '../containers/GIPolicyList'
import GIPolicyDetailContainer from '../containers/GIPolicyDetailContainer'
import GIOutstandingRequirementContainer from '../containers/GIOutstandingRequirementContainer'

export default {
  path: 'gi',
  name: 'General Insurance',
  component: GIPolicy,
  redirect: '/osm/gi/list',
  meta: { label: 'osm.contents.giPolicy.header' },
  children: [{
    path: 'new',
    name: 'Create GI Policy',
    props: true,
    meta: { label: 'osm.contents.giPolicy.new' },
    component: NewGIPolicyContainer
  }, {
    path: 'list',
    name: 'GI Policy List',
    meta: { label: 'osm.contents.giPolicy.giPolicyList' },
    props: true,
    component: GIPolicyList
  }, {
    path: 'detail',
    name: 'GI Detail',
    meta: { label: 'osm.contents.giPolicy.giPolicyDetail' },
    component: GIPolicyDetailContainer
  }, {
    path: 'or',
    name: 'GI Outstanding Requirement',
    meta: { label: 'osm.contents.giPolicy.giOr' },
    component: GIOutstandingRequirementContainer
  }]
}



// WEBPACK FOOTER //
// ./src/Osm/GIPolicy/route/index.js